import { FlattenedQuestionHolder } from "./Audits/flattened-question-holder";
import { AuditLocation } from "./Locations/audit-location";

export class UserLocationSave{
    Username: string = "";
    Location: AuditLocation;
    AuditGUID: string = "";
    LastUpdate:Date = new Date();
    LastUpdateSet:boolean = false;
    FlattenedQuestions:FlattenedQuestionHolder[] = [];
    CloudSave:boolean = false;
    constructor(values: Object = {}) {        
        Object.assign(this, values);
        if(values.hasOwnProperty('LastUpdate')){
            this.LastUpdate = new Date((values as UserLocationSave)['LastUpdate']);
        }
        if (values.hasOwnProperty('FlattenedQuestions')) {
            this.FlattenedQuestions = [];
            ((values as UserLocationSave)['FlattenedQuestions'] as FlattenedQuestionHolder[]).forEach(element => {
                this.FlattenedQuestions.push(new FlattenedQuestionHolder(element));
            });
        }
        if (values.hasOwnProperty('Location')) {
            this.Location = new AuditLocation((values as UserLocationSave)['Location'] as AuditLocation);
        }
    }
}